module.exports = __webpack_public_path__ + "media/images/patterns/img-placeholder-52a48ce6c4a3cb17fd4d769789474822.png";